export default __webpack_public_path__ + "static/media/SmartBear-Logo.eac19c1f.svg";